// services/baseQuery.ts
import { fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { RootState } from '../store/store';
import { setTokens, resetTokens } from '../store/reducers/authReducer';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://api.memora.sbs/api').replace(/\/$/, '');
console.log('[API] Base URL =', API_BASE_URL);

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.accessToken;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
  credentials: 'include', 
});

export const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    api,
    extraOptions
  ) => {
    try {
      const info = typeof args === 'string' ? { url: args, method: 'GET' } : { url: args.url, method: (args as any).method || 'GET' };
      console.debug('[API][REQUEST]', info.method, info.url, { hasBody: typeof args !== 'string' && !!(args as any).body });
    } catch {}

    let result = await rawBaseQuery(args, api, extraOptions);
  
    if (result.error && result.error.status === 401) {
      // Attempt refresh
      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) {
        api.dispatch(resetTokens());
        return result;
      }

      const refreshResult = await rawBaseQuery(
        {
          url: '/users/refresh',
          method: 'POST',
          body: { refreshToken },
        },
        api,
        extraOptions
      );
  
      if (refreshResult.data && (refreshResult.data as any).data?.accessToken) {
        const newAccessToken = (refreshResult.data as any).data.accessToken;
  
        // Save to localStorage and Redux
        localStorage.setItem('access_token', newAccessToken);
        api.dispatch(setTokens({ accessToken: newAccessToken, refreshToken: refreshToken }));
  
        // Retry the original query
        result = await rawBaseQuery(args, api, extraOptions);
      } else {
        // If refresh fails, logout
        api.dispatch(resetTokens());
      }
    }
    if (result.error) {
      const info = typeof args === 'string' ? { url: args, method: 'GET' } : { url: (args as any).url, method: (args as any).method || 'GET' };
      console.warn('[API][ERROR]', info.method, info.url, { status: result.error.status, data: (result as any).data });
    } else {
      try {
        const info = typeof args === 'string' ? { url: args, method: 'GET' } : { url: (args as any).url, method: (args as any).method || 'GET' };
        console.debug('[API][RESPONSE]', info.method, info.url, { ok: true });
      } catch {}
    }

    return result;
  };
  
